// core version + navigation, pagination modules:
// import SwiperCore, { Navigation, Pagination } from 'swiper/core';

// configure Swiper to use modules
// SwiperCore.use([Navigation, Pagination]);
/*[
    "assets/vendor/swiper.js",
    "assets/vendor/gsap.min.js",
    "assets/vendor/ScrollTrigger.min.js",
    "assets/scripts/defaults.js",
    "assets/scripts/menu.js",
    "assets/scripts/animations.js",
    "assets/scripts/modal.js",
    "assets/scripts/scripts.js"
]*/

import defaults from './defaults.js';
defaults();

import animations from './animations.js';
animations();

import menu from './menu.js';
menu();

import dialog from './dialog.js';
dialog();

import search from './search.js';
search();

import sliders from './sliders.js';
sliders();
import informations from './informations.js';
informations();

import woo from './woocommerce.js';
woo();

import './cookie-bar'
import './shop/archive-product/archive-product'
import './shop/archive-product/product-variations'
import './shop/cart/cart-ajax'
import './shop/checkout/checkout'
import './shop/checkout/checkout-ajax'
// import './shop/checkout/checkout-cp-np'
import './shop/checkout/checkout-dpd'
import './shop/checkout/checkout-ppl'
import './shop/checkout/checkout-posta-bez-hranic'
import './shop/checkout/checkout-zasilkovna'
import './shop/checkout/order-pay-ajax'
import './shop/checkout/coupons'
import './shop/my-account/cancel-order'
import './shop/my-account/edit-account'
import './shop/my-account/register'
import './shop/my-account/lost-password'
import './shop/common-forms'
import './shop/datalayer/datalayer'
import './shop/single-product/product-variation-detail-ajax'
import './shop/single-product/restock-reminder'
import showroom from './showroom.js';

showroom();

import './b2b-registration'
import './business-account-request-eu'

import bar from './bar.js';
bar();

import tippy from "tippy.js";
// import {roundArrow} from 'tippy.js';

import "./country-popup";

import { polyfillCountryFlagEmojis } from "country-flag-emoji-polyfill";
polyfillCountryFlagEmojis();

jQuery(document).on("ready ajax_products_loaded", function (){
	tippy('[data-tippy-content]', {
		theme: 'bennon',
		placement: 'top-start',
		duration: [200, 200],
	});
})


